import React from 'react';

import { Box, Typography } from '@mui/material';

import strings from '../../../../localization';

import styles from './styles';

const LongTermNote = () =>
  (
    <Box sx={styles.container}>
      <Typography sx={styles.note}>
        {strings.onAcceptingThisRequestNote}
      </Typography>
    </Box>
  );

export default LongTermNote;
